/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IPharmacyConsumableStock } from 'app/shared/model/pharmacy-consumable-stock.model';
import { IPharmacyImplantStock } from 'app/shared/model/pharmacy-implant-stock.model';
import { IPharmacyStock } from 'app/shared/model/pharmacy-stock.model';
import { IPharmacy } from 'app/shared/model/pharmacy.model';

export interface IPharmacyStockClosure {
  id?: string;
  microSec?: number;
  lastupdated?: number;
  active?: boolean;
  cursor?: number;
  remainingQuantity?: number | null;
  forDate?: number;
  consumableStock?: IPharmacyConsumableStock | null;
  implantStock?: IPharmacyImplantStock | null;
  drugStock?: IPharmacyStock | null;
  pharmacy?: IPharmacy;
}

export const defaultValue: Readonly<IPharmacyStockClosure> = {
  active: false,
};
